export default "__VITE_ASSET__S6XILn8Y__"